<!-- <main class="container-login">
  <section class="login">
    <article class="article-login">

      <div class="card">
        <h4 class="card-header">Casos Clínicos</h4>
        <div class="card-body">
          <form id="form-id" [formGroup]="form" (ngSubmit)="acceder()">
            <section>
              <label for="user">Usuario</label>
              <input type="text" id="user" name="user" placeholder="Usuario" formControlName="username">
            </section>
            <section>
              <label for="pass">Contraseña</label>
              <input type="password" id="pass" name="pass" placeholder="Password" formControlName="contrasena">
            </section>
            <nav class="flex justify-content-between">
              <button class="boton-cc" type="submit" name="button">login</button>
              <a [routerLink]="['/registrar']">registrar</a>
            </nav>
          </form>
        </div>
      </div>

    </article>
    <article class="article-img">
      <div class="container-img"></div>
    </article>
  </section>
</main>
<p-toast></p-toast> -->

<main class="container-login">
  <section class="login">
    <article class="article-login">
      <div class="card">
        <div class="card-header">
          <h2>Bienvenido</h2>
          <p class="subtitle">Inicia sesión en Casos Clínicos</p>
        </div>
        
        <div class="card-body">
          <form id="form-id" [formGroup]="form" (ngSubmit)="acceder()">
            <div class="input-group">
              <label for="user">
                <i class="pi pi-user"></i>
                Usuario
              </label>
              <input 
                type="text" 
                id="user" 
                name="user" 
                placeholder="Ingresa tu usuario"
                formControlName="username"
                [class.error]="form.get('username')?.invalid && form.get('username')?.touched">
              <small 
                class="error-message" 
                *ngIf="form.get('username')?.invalid && form.get('username')?.touched">
                El usuario es requerido
              </small>
            </div>

            <div class="input-group">
              <label for="pass">
                <i class="pi pi-lock"></i>
                Contraseña
              </label>
              <input 
                type="password" 
                id="pass" 
                name="pass" 
                placeholder="Ingresa tu contraseña"
                formControlName="contrasena"
                [class.error]="form.get('contrasena')?.invalid && form.get('contrasena')?.touched">
              <small 
                class="error-message" 
                *ngIf="form.get('contrasena')?.invalid && form.get('contrasena')?.touched">
                La contraseña es requerida
              </small>
            </div>

            <div class="form-options">
              <div class="remember-me">
                <input 
                  type="checkbox" 
                  id="remember" 
                  formControlName="isRecordarUsuario">
                <label for="remember">Recordar usuario</label>
              </div>
                <a [routerLink]="['/recuperar-password']" class="forgot-password">
                  ¿Olvidaste tu contraseña?
                </a>
              </div>

            <button 
              class="btn-login" 
              type="submit" 
              [disabled]="form.invalid"
              [class.btn-loading]="isLoading">
              <span *ngIf="!isLoading">Iniciar Sesión</span>
              <span *ngIf="isLoading" class="loader"></span>
            </button>

            <div class="register-link">
              <span>¿No tienes una cuenta?</span>
              <a [routerLink]="['/registrar']">Regístrate aquí</a>
            </div>
          </form>
        </div>
      </div>
    </article>

    <article class="article-img">
      <div class="container-img">
        <div class="img-overlay">
          <h2>Casos Clínicos</h2>
          <p>Gestiona tus casos clínicos de manera eficiente</p>
        </div>
      </div>
    </article>
  </section>
</main>
<p-toast></p-toast>